import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SKIP = ["/auth/refresh", "/auth/login", "/auth/logout", "/auth/forgot-password", "/auth/reset-password"];

let refreshing = null;
export function refreshSession() {
  if (!refreshing) {
    refreshing = axios
      .post(`${API}/auth/refresh`, {}, { withCredentials: true })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

export function attachRefresh(instance, onFail) {
  instance.interceptors.response.use(
    (r) => r,
    async (error) => {
      const original = error.config;
      const url = original?.url || "";
      if (error.response?.status === 401 && original && !original._retry && !SKIP.some((s) => url.includes(s))) {
        original._retry = true;
        try {
          await refreshSession();
          return instance(original);
        } catch (e) {
          if (onFail) onFail();
          return Promise.reject(e);
        }
      }
      return Promise.reject(error);
    }
  );
}
